import { Button, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import FactoryOne from "../../../../customer/assets/paypalOne.png";
import FactoryTwo from "../../../../customer/assets/paypal2.png";
import FactoryThree from "../../../../customer/assets/factoryIcon.png";
import SizingIcon from "../../../../customer/assets/sizingTableIcon.png";
import Placeholder from "../../../assets/image-placeholder.svg";
import ExtraRequestMessages from "../../../../customer/pages/products/components/ExtraRequestMessages";
import { useDispatch, useSelector } from "react-redux";
import { productSelector } from "../../../../../redux/slices/productSlice";
import {
  emptyUploadedMediaFile,
  orderSelector,
} from "../../../../../redux/slices/orderSlice";
import { uploadFile } from "../../../../../api/order";
import { updateProduct } from "../../../../../api/product";
import FactoryPicturesField from "./FactoryPicturesField";

export default function NewExtraRequestWithMessage({
  product,
  boxShadow,
  handleClose,
}) {
  const { admin_note } = useSelector(productSelector);

  const { uploadedMediaFile } = useSelector(orderSelector);
  const dispatch = useDispatch();
  const [isLoadingSizing, setIsLoadingSizing] = useState(false);
  // sizing table media part
  const [previewSizingTable, setPreviewSizingTable] = useState();
  const [sizingTableFileLink, setSizingTableFileLink] = useState(null);
  const [sizingTable, setSizingTable] = useState(product?.sizing_table);

  // Factory pictures: a list, older products only have the single factory_picture.
  const [factoryPictures, setFactoryPictures] = useState(() =>
    product?.factory_pictures?.length
      ? product.factory_pictures
      : product?.factory_picture && product.factory_picture !== "Not available"
      ? [{ url: product.factory_picture, mime_type: product?.quotation_request?.options?.option1MimeType }]
      : []
  );
  // "Not available" when the team can't get pictures, otherwise the first picture.
  const [factoryPicture, setFactoryPicture] = useState(
    product?.factory_picture
  );
  const changeFactoryPictures = (pictures) => {
    setFactoryPictures(pictures);
    setFactoryPicture(pictures[0]?.url);
  };
  const [sizingTableMimeType, setSizingTableMimeType] = useState(null);

  const uploadMedia = () => {
    const formData = new FormData();
    formData.append("media", sizingTableFileLink);
    setIsLoadingSizing(true);
    dispatch(uploadFile(formData)).then(() => setIsLoadingSizing(false));
  };

  useEffect(() => {
    if (sizingTableFileLink) {
      uploadMedia();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sizingTableFileLink]);

  useEffect(() => {
    if (uploadedMediaFile?.media) {
      if (previewSizingTable && sizingTableFileLink) {
        setSizingTable(uploadedMediaFile.media);
        setSizingTableFileLink(null);
      }

      dispatch(emptyUploadedMediaFile(null));
    }
  }, [
    previewSizingTable,
    uploadedMediaFile?.media,
    sizingTableFileLink,
    dispatch,
  ]);

  const hasEveryVariantOriginalPrice = product?.variants?.some(
    (variant) => variant?.original_price !== undefined
  );

  const handleDispatch = () => {
    if (product?._id) {
      dispatch(
        updateProduct({
          productId: product?._id,
          updatePayload: {
            quotation_request: {
              additional_notes: {
                client_note:
                  product?.quotation_request?.additional_notes?.client_note,
                admin_note:
                  admin_note ||
                  product?.quotation_request?.additional_notes?.admin_note,
              },
              options: {
                option1: product?.quotation_request?.options?.option1,
                option1MimeType: factoryPictures[0]?.mime_type || product?.quotation_request?.options?.option1MimeType,
                option2: product?.quotation_request?.options?.option2,
                option2MimeType: sizingTableMimeType || product?.quotation_request?.options?.option2MimeType,
              },
            },
            sizing_table:
              product?.quotation_request?.options?.option2 &&
              sizingTable !== "Not available"
                ? sizingTable
                : null,
            factory_picture:
              product?.quotation_request?.options?.option1 &&
              factoryPicture !== "Not available"
                ? factoryPictures[0]?.url || null
                : null,
            factory_pictures:
              product?.quotation_request?.options?.option1 &&
              factoryPicture !== "Not available"
                ? factoryPictures
                : [],
            status:
              product?.status !== "accepted" && !hasEveryVariantOriginalPrice
                ? product?.status
                : "accepted",
            requote_request: "APPROVED",
          },
        })
      ).then(() => {
        dispatch(emptyUploadedMediaFile(null));
        handleClose();
      });
    }
  };

  const productURL = `https://${product?.store?.store_name}/products/${product?.handle}`;
  const shortenedURL =
    productURL.length > 30 ? `${productURL.substring(0, 30)}...` : productURL;

  const option1 = product?.quotation_request?.options?.option1;
  const option2 = product?.quotation_request?.options?.option2;

  const isDisabled = () => {
    if (option1 && !factoryPicture) return true;
    if (option2 && !sizingTable) return true;
    if (option1 && option2 && (!sizingTable || !factoryPicture)) return true;
    if (isLoadingSizing) return true;
    return false;
  };

  console.log("sizing table file type", sizingTableMimeType);
  return (
    <>
      <div style={{ boxShadow: boxShadow, borderRadius: "5px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginTop: "20px",
            padding: "20px",
            borderRadius: "7.5px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <img
              src={product?.images[0]?.src || Placeholder}
              alt="productimage"
              style={{ width: "40px", height: "40px", borderRadius: "5px" }}
            />
            <h4
              style={{ fontSize: "16px", marginLeft: "20px", color: "#344054" }}
            >
              {product?.title || "N/A"}
            </h4>
          </div>
          <a
            href={productURL}
            target="_blank"
            rel="noreferrer"
            style={{ color: "#344054" }}
          >
            {shortenedURL}
          </a>
        </div>
        {product?.quotation_request?.options?.option1 && (
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              padding: "5px 20px",
              borderRadius: "7.5px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "20px",
                  marginTop: "5px",
                }}
              >
                <img src={FactoryOne} alt="page_image" />
                <img
                  src={FactoryTwo}
                  alt="page_image"
                  style={{ marginTop: -33, marginBottom: "20px" }}
                />
                <img
                  src={FactoryThree}
                  alt="page_image"
                  style={{ marginTop: -45, marginBottom: "20px" }}
                />
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setFactoryPictures([]);
                    setFactoryPicture("Not available");
                  }}
                >
                  <h4
                    style={{
                      fontSize: "16px",
                      lineHeight: 1.5,
                      marginBottom: 0,
                      color: "#344054",
                      marginRight: "40px",
                    }}
                  >
                    Factory product pictures
                  </h4>
                  {!factoryPicture && (
                    <strong
                      style={{
                        textDecoration: "underline",
                        color: "#FF7F7F",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      Not available
                    </strong>
                  )}
                </div>
                {factoryPicture === "Not available" ? (
                  <strong
                    onClick={() => setFactoryPicture(undefined)}
                    style={{ textDecoration: "underline", color: "#7f56d9", fontSize: "14px", cursor: "pointer" }}
                  >
                    Undo, upload pictures instead
                  </strong>
                ) : (
                  <FactoryPicturesField pictures={factoryPictures} onChange={changeFactoryPictures} />
                )}
              </div>
            </div>
          </div>
        )}
        {product?.quotation_request?.options?.option2 && (
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              padding: "5px 20px",
              borderRadius: "7.5px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "20px",
                  marginTop: "5px",
                }}
              >
                <img src={FactoryOne} alt="page_image" />
                <img
                  src={FactoryTwo}
                  alt="page_image"
                  style={{ marginTop: -33, marginBottom: "20px" }}
                />
                <img
                  src={SizingIcon}
                  alt="page_image"
                  style={{ marginTop: -45, marginBottom: "20px" }}
                />
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => setSizingTable("Not available")}
                >
                  <h4
                    style={{
                      fontSize: "16px",
                      lineHeight: 1.5,
                      marginBottom: 0,
                      color: "#344054",
                      marginRight: "40px",
                    }}
                  >
                    Sizing table
                  </h4>
                  {!sizingTable && (
                    <strong
                      style={{
                        textDecoration: "underline",
                        color: "#FF7F7F",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      Not available
                    </strong>
                  )}
                </div>
                {sizingTable ? (
                  <div>
                    <a
                      href={`${sizingTable}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#7F56D9", marginRight: "40px" }}
                    >
                      {sizingTable?.length > 30
                        ? `${sizingTable?.substring(0, 30)}...`
                        : sizingTable}
                    </a>

                    <strong
                      onClick={() => {
                        setSizingTable();
                        setSizingTableMimeType();
                      }}
                      style={{
                        textDecoration: "underline",
                        color: "#FF7F7F",
                        fontSize: "14px",
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                    >
                      Remove
                    </strong>
                  </div>
                ) : (
                  <IconButton
                    style={{
                      color: "transparent",
                      marginTop: -5,
                      marginLeft: -5,
                    }}
                    onChange={(e) => {
                      setSizingTableFileLink(e.target.files[0]);
                      setSizingTableMimeType(e.target.files[0]?.type);
                      setPreviewSizingTable(
                        URL.createObjectURL(e.target.files[0])
                      );
                    }}
                    //   color="primary"
                    aria-label="upload picture"
                    component="label"
                    // sx={{ position: "absolute", bottom: 10, right: 10 }}
                  >
                    <input hidden accept="image/*, video/*" type="file" />
                    <strong
                      style={{
                        color: "#7f56d9",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      {isLoadingSizing ? "Uploading" : "Upload*"}
                    </strong>
                    {/* <Icon icon="bi:cloud-upload" width="40" height="40" /> */}
                  </IconButton>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        style={{
          boxShadow: boxShadow,
          borderRadius: "5px",
          padding: "20px 0px",
          marginTop: "20px",
        }}
      >
        <ExtraRequestMessages product={product} adminSide={true} />
      </div>

      <div style={{ textAlign: "right" }}>
        <Button
          onClick={() => {
            handleDispatch();
          }}
          disabled={isDisabled()}
          variant="lightblue"
          sx={{
            width: "auto",
            marginTop: "50px",
            marginBottom: 0,
            background: "#210C43",
            boxShadow: "none",
            ":hover": {
              background: "#210C43",
            },
          }}
        >
          Submit
        </Button>
      </div>
    </>
  );
}
